import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[100vh] min-h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/db5a47e3d4c017797ed870ac31443194.jpg"
          alt="Vikings Stadium"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-6 flex flex-col items-center">
        <p
          className="text-white/70 text-xs tracking-[0.4em] uppercase mb-4 flex items-center gap-3"
          style={{ fontFamily: "'Oswald', sans-serif" }}
        >
          <span className="inline-block w-8 h-px bg-white/50"></span>
          Welcome to the
          <span className="inline-block w-8 h-px bg-white/50"></span>
        </p>

        <h1
          className="text-white font-black uppercase leading-none mb-4"
          style={{
            fontFamily: "'Oswald', sans-serif",
            fontSize: 'clamp(3.5rem, 10vw, 9rem)',
            letterSpacing: '-0.02em',
          }}
        >
          <span className="text-[#ffd700]">Purple</span>{' '}
          <span className="text-white">Pride</span>
        </h1>

        <p
          className="text-white/80 text-sm md:text-base tracking-[0.3em] uppercase mb-10"
          style={{ fontFamily: "'Oswald', sans-serif" }}
        >
          Home of Vikings Fans Worldwide
        </p>

        <div className="flex flex-col sm:flex-row gap-4 items-center">
          <Link
            to="/news"
            className="whitespace-nowrap px-8 py-3 rounded-full bg-[#ffd700] text-[#4a1a6b] font-bold text-sm tracking-widest uppercase cursor-pointer hover:bg-white transition-all duration-300"
            style={{ fontFamily: "'Oswald', sans-serif" }}
          >
            Latest News
          </Link>
          <Link
            to="/forums"
            className="whitespace-nowrap px-8 py-3 rounded-full border-2 border-white text-white font-bold text-sm tracking-widest uppercase cursor-pointer hover:bg-white hover:text-[#4a1a6b] transition-all duration-300"
            style={{ fontFamily: "'Oswald', sans-serif" }}
          >
            Join Forums
          </Link>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/50 text-xs tracking-widest uppercase" style={{ fontFamily: "'Oswald', sans-serif" }}>Scroll</span>
        <i className="ri-arrow-down-line text-white/50 text-lg"></i>
      </div>
    </section>
  );
}
